import React from 'react';

import { } from './CheckPointDetailView.css'
import {
    Row,
    Col,
    Label
} from 'reactstrap';

import CheckpointCard from '../CheckpointCard/CheckpointCard'
import Strings from '../../../strings/Strings'
import { latestCheckpoint } from '../../../utils/latestCheckpoint'
import StudentDetailInfoMessage from '../../StudentInfo/StudentInfoDetailMessage/StudentInfoDetailMessage'

const CheckPointDetailView = (props) => {

    let checkpointCard = [];
    if (props.student && props.student.checkpoints){
        const current = latestCheckpoint(props.student);
        const checkpoints = [...props.student.checkpoints].sort((left, right) => {
            if (current && left === current) {
                return -1;
            }
            if (current && right === current) {
                return 1;
            }
            return 0;
        });
        checkpointCard = checkpoints.map((checkpoint, index) => {
            return <CheckpointCard key={checkpoint.id || index} checkpoint={checkpoint} />;
        });        
    }

    return (
        <div>
            <StudentDetailInfoMessage
                student={props.student}
                showSendMessageBox={props.showSendMessageBox}
                onSendNewMessage={props.onSendNewMessage}
                onSendMessageChangeValue={props.onSendMessageChangeValue}
                onShowSendMessageBox={props.onShowSendMessageBox}
                sendMessageText={props.sendMessageText}
                sendErrorMessage={props.sendErrorMessage}
                isSending={props.isSending}
                codeReturn={props.codeReturn}

             />
            <Row className="rowInfo text-center permanentAuthBar" >
                <Col md={12} >
                    <Label className="titleResp">{Strings.checkpoint.checkpoints}</Label>
                </Col>
            </Row>
            <Row className="rowInfo text-center" >
                {checkpointCard}   
            </Row>  
        
        </div>
    )
}


export default CheckPointDetailView;